import {
    CATEGORY_REQUEST,
    CATEGORY_SUCCESS,
    CATEGORY_FAILURE,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    products: [],
    count: null,
    error: null,
};

export default function categoryReducer(state = initialState, action) {
    switch (action.type) {
        case CATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CATEGORY_SUCCESS:
            return {
                ...state,
                // always replacing data
                count: action.data.products.length,
                products: action.data.products,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case CATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
